import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

export default {
  id: 'MOD_LIST_PERS',
  title: 'Un modello di Lista del Personale?',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Se si desidera presentare una lista del personale, si prega di prendere il seguente modello:'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: `${pathHelpContentFile}it/IT_MOD_LIST_PERS/Liste personnel ok.xlsx`,
    label: 'Lista del Personale.'
  }]
};
